// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"pageContent__A+CBz"};